export class Testimonial {
    constructor(first: string, last: string, position: string, quote: string, firm: Firm){
        this.first = first;
        this.last = last;
        this.position = position;
        this.quote = quote;
        this.firm = firm;
    }

    public first: string;
    public last: string;
    public position: string;
    public quote: string;
    public firm: Firm;

    public get fullname(): string{
        return `${this.first} ${this.last}`;
    }
}

export class Firm{
    constructor(name: string, website: string = null, logo: string = null){
        this.name = name;
        this.website = website;
        this.logo = logo;
    }
    public name: string;
    public logo: string;
    public website: string;
    
}